import React from 'react';
import { Shield, FlaskConical, CheckCircle } from 'lucide-react';
import PageBanner from '../layout/PageBanner';
import SectionHeading from '../ui/SectionHeading';
import { manufacturing } from '../../data/company';

const ManufacturingPage = () => {
  return (
    <div>
      <PageBanner
        title="EXCELLENCE IN MANUFACTURING"
        breadcrumbs={[{ label: 'MANUFACTURING' }]}
      />

      {/* Plant Certification */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <SectionHeading title="State of the Art Manufacturing Plant" />
          <p className="text-gray-600 leading-relaxed text-center">
            {manufacturing.plantCertification}
          </p>
        </div>
      </section>

      {/* Quality & Lab Sections */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Quality Assurance */}
          <div className="bg-white p-8 rounded-lg shadow-md">
            <div className="flex items-center gap-4 mb-4">
              <Shield size={40} className="text-primary-red" />
              <h3 className="text-xl font-serif font-bold">Quality Assurance</h3>
            </div>
            <p className="text-gray-600 leading-relaxed">
              {manufacturing.qualityAssurance}
            </p>
          </div>

          {/* Lab Certification */}
          <div className="bg-white p-8 rounded-lg shadow-md">
            <div className="flex items-center gap-4 mb-4">
              <FlaskConical size={40} className="text-primary-red" />
              <h3 className="text-xl font-serif font-bold">FDA and USDA Certified Food Lab</h3>
            </div>
            <p className="text-gray-600 leading-relaxed mb-4">
              {manufacturing.labCertification}
            </p>
            <ul className="space-y-2">
              {manufacturing.labCapabilities.map((capability, index) => (
                <li key={index} className="flex items-center gap-2 text-gray-600">
                  <CheckCircle size={16} className="text-primary-red" />
                  {capability}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Testing Procedures */}
      <section className="py-16 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <SectionHeading title="Product Testing Procedures" />
          <p className="text-gray-600 leading-relaxed">
            {manufacturing.testing}
          </p>
        </div>
      </section>

      {/* Custom Products */}
      <section className="py-16 px-6 bg-primary-red text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-serif font-bold mb-8">Custom Blend Products</h2>
          <div className="flex flex-wrap justify-center gap-3">
            {manufacturing.customProducts.map((product, index) => (
              <span
                key={index}
                className="px-4 py-2 bg-white/10 rounded-full text-sm"
              >
                {product}
              </span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManufacturingPage;
